
  import { defineComponent, inject } from "vue";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import { get, isNil, set } from "lodash";

  export default defineComponent({
    name: "NumericInputV2",

    extends: BaseProcessComponentV2,

    data() {
      return {
        defaultValue: null as any,
        numericValue: null as string | null,
        loading: false as boolean,
        max: null as number | null,
        min: null as number | null,
        prefix: null as string | null,
      };
    },

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    created() {
      if (!isNil(this.value)) {
        this.numericValue = this.value;
      }
    },

    computed: {
      value: {
        get(): any {
          return get(this, this.path, this.defaultValue);
        },

        set(value: any) {
          if (this.attributes.output_format === "raw" && this.numericValue) {
            value = this.numericValue.replaceAll(",", "");

            if (this.attributes.return_type === "number") {
              set(this, this.path, Number(value))
            } else {
              set(this, this.path, value)
            }

          } else {
            set(this, this.path, value)
          }

          this.internalValue = value;
        },
      },
    },

    methods: {
      executeClearAction() {
        set(this, this.path, null);
        this.numericValue = null;
        this.max = null;
        this.min = null;
        this.prefix = null;
      },
    },

    watch: {
      numericValue(newVal, oldVal) {
        if (oldVal !== null) {
          this.value = newVal;
        }
      },
    },
  });
